import { client } from "../../../../actions";
import { authHeader } from "../../../../helpers/auth-header";
import { getOneVoting } from "./get-one-voting";
import { message } from "antd";

export const startVoting = (voting) => async (dispatch) => {
	try {
		await client.put(
			"/Voting/state",
			{
				Id: voting.id,
				StateId: 4,
			},
			{
				headers: authHeader(),
			}
		);
		await dispatch(getOneVoting(voting.id));
	} catch (e) {
		console.error(e);
		message.error("Не получилось запустить опрос, попробуйте позже");
	}
};

export const stopVoting = (voting) => async (dispatch) => {
	try {
		await client.put(
			"/Voting/state",
			{
				Id: voting.id,
				StateId: 3,
			},
			{
				headers: authHeader(),
			}
		);
		dispatch(getOneVoting(voting.id));
	} catch (e) {
		console.error(e);
		message.error("Не получилось завершить опрос, попробуйте позже");
	}
};

export const cancelVoting = (voting) => async (dispatch) => {
	try {
		if (voting.state.id === 4) {
			const responce = await client.put(
				"/Voting/state",
				{
					Id: voting.id,
					StateId: 1,
				},
				{
					headers: authHeader(),
				}
			);
			if (
				responce.data.result === "Error" &&
				responce.data.message === "Опрос активен"
			) {
				message.error(
					"Опрос уже запущен, его нельзя отменить. Вы сможете досрочно завершить его"
				);
			}
			dispatch(getOneVoting(voting.id));
		} else {
			dispatch(stopVoting(voting));
		}
	} catch (e) {
		console.error(e);
		message.error("Не получилось отменить опрос, попробуйте позже");
	}
};
